import { render, staticRenderFns } from "./config.vue?vue&type=template&id=bd3ddc9c&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3ddc9c",
  null
  
)

export default component.exports